import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

/**
 * The LumberSet mark: a carpenter's framing square. It reads as an "L" and it
 * is the tool an estimator measures with.
 */
export function LogoMark({ className, ...props }: ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={cn("size-6 shrink-0", className)}
      {...props}
    >
      {/* The fill and stroke attributes are fallbacks for when the stylesheet is absent. */}
      <rect width="24" height="24" rx="6" className="fill-ui-contrast-bg-base" fill="#18181B" />
      <path
        d="M7 5.25h3.25V15.5H18v3.25H7V5.25Z"
        className="fill-ui-contrast-fg-primary"
        fill="#fff"
      />
      <path
        d="M10.25 8h-1.5M10.25 10.5h-1.5M10.25 13h-1.5M12.75 15.5V17M15.25 15.5V17"
        className="stroke-ui-contrast-bg-base"
        stroke="#18181B"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Logo({
  className,
  markClassName,
  ...props
}: ComponentProps<"span"> & { markClassName?: string }) {
  return (
    <span
      className={cn(
        "inline-flex select-none items-center gap-x-2 text-[15px] font-semibold leading-none tracking-[-0.02em] text-ui-fg-base",
        className,
      )}
      {...props}
    >
      <LogoMark className={markClassName} />
      <span>LumberSet</span>
    </span>
  );
}
